import { isReduxHostInitialized, getReduxHost } from "./host/redux-host.js";
import "@reduxjs/toolkit";
function getStore() {
  return getHost().getStore();
}
function isReducerRegistered(name) {
  return getHost().isReducerRegistered(name);
}
function registerReducer(name, reducer, replace = false) {
  getHost().registerReducer(name, reducer, replace);
}
function unregisterReducer(name) {
  getHost().unregisterReducer(name);
}
function getHost() {
  if (!isReduxHostInitialized()) {
    throw new Error(`Redux host is not initialized. Please initialize it first.`);
  }
  return getReduxHost().get();
}
export {
  getStore,
  isReducerRegistered,
  registerReducer,
  unregisterReducer
};
//# sourceMappingURL=redux-client.js.map
